hasProtocolErrors